import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { COLORS } from '../constants/constants';
import { useTranslation } from 'react-i18next';



export default function AboutiCoachBasketballSection() {
    const { t } = useTranslation();

    const ITEMS = [
        {
            label: t('AboutiCoachBasketballSection00'),
            total: 20000,
            content: t('AboutiCoachBasketballSection03'),
        },
        {
            label: t('AboutiCoachBasketballSection01'),
            total: 35000,
            content: t('AboutiCoachBasketballSection04'),
        },
        {
            label: t('AboutiCoachBasketballSection02'),
            total: 5000,
            content: t('AboutiCoachBasketballSection05'),
        },
    ];
    return (
        <Container
            component="section"
            sx={{
                py: { xs: 5, md: 10 },
                mt: { xs: 5, md: 8 },
                maxWidth: '1200px'
            }}
        >
            <Grid container spacing={{ xs: 3, md: 6 }}>
                {/* Text Section */}
                <Grid item xs={12} md={5}>
                    <Typography
                        variant="overline"
                        sx={{
                            color: 'text.disabled',
                            textAlign: { xs: 'center', sm: 'left' },
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            letterSpacing: '0.1em',
                            display: 'block'
                        }}
                    >
                        {t('AboutiCoachBasketballSection06')}
                    </Typography>

                    <Typography
                        variant="h2"
                        sx={{
                            my: 3,
                            fontFamily: 'Barlow, sans-serif',
                            textAlign: { xs: 'center', sm: 'left' },
                            fontSize: { xs: '2.5rem', md: '3.2rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            color: '#1a202c'
                        }}
                    >
                        {t('AboutiCoachBasketballSection07')}
                    </Typography>

                    <Typography
                        sx={{
                            color: 'text.secondary',
                            textAlign: { xs: 'center', sm: 'left' },
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.6,
                            maxWidth: 480
                        }}
                    >
                        {t('AboutiCoachBasketballSection08')}
                    </Typography>
                </Grid>

                {/* Stats Section */}
                <Grid item xs={12} md={7}>
                    <Grid container spacing={3}>
                        {ITEMS.map((item) => (
                            <Grid item xs={12} key={item.label}>
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={3}>
                                        <Typography
                                            variant="h2"
                                            sx={{
                                                fontFamily: 'Barlow, sans-serif',
                                                fontSize: { xs: '2rem', md: '2.5rem' },
                                                fontWeight: 800,
                                                color: '#1a202c',
                                                lineHeight: 1
                                            }}
                                        >
                                            {item.total >= 1000 ? `${(item.total / 1000).toFixed(0)}k` : item.total}
                                            <Typography
                                                component="span"
                                                sx={{
                                                    color: COLORS.blueICB,
                                                    fontFamily: 'Barlow, sans-serif',
                                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                                    fontWeight: 800,
                                                    ml: 0.5
                                                }}
                                            >
                                                +
                                            </Typography>
                                        </Typography>
                                        <Typography
                                            variant="overline"
                                            sx={{
                                                color: 'text.disabled',
                                                fontFamily: 'Barlow, sans-serif',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                letterSpacing: '0.1em'
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={9}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'text.secondary',
                                                fontFamily: 'Barlow, sans-serif',
                                                fontSize: '0.95rem',
                                                lineHeight: 1.5
                                            }}
                                        >
                                            {item.content}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
}